export const selectAppLoading = (state) => state.app.loading;
export const selectStripePaymentData = (state) => ({ clientSecret: state.app.clientSecret, stripePaymentIntentId: state.app.stripePaymentIntentId, paymentMethodType: state.app.paymentMethodType });
export const selectPayments = (state) => state.app.payments;
export const selectBalance = (state) => state.app.totalBalance;
export const selectPayoutsLost = (state) => state.app.payoutsLost;
